import { createModule } from 'saga-slice';
import {
  fetchBusinessUnitsSagaFactory,
  fetchUsersBusinessUnitsSagaFactory,
} from './sagas';
import { initialState, SelectDataState } from './stateType';
import { BusinessUnit } from '../../models/buniessUnitType';
import { CountryType } from '../../models/countryUnitActuals';

const Slice = createModule({
  name: 'selectData',
  initialState,
  reducers: {
    selectCountryCodes: (state: SelectDataState, payload: CountryType[]) => {
      state.selectedCountryCodes = payload;
    },
    fetchUserBusinessUnits: (state: SelectDataState) => {
      state.loading = true;
      state.error = null;
    },
    fetchBusinessUnits: (state: SelectDataState) => {
      state.loading = true;
      state.error = null;
    },
    fetchBusinessUnitsSuccess: (
      state: SelectDataState,
      payload: BusinessUnit[],
    ) => {
      state.loading = false;
      state.businessUnits = payload;
    },
    fetchBusinessUnitsError: (state: SelectDataState, payload: string) => {
      state.loading = false;
      state.error = payload;
    },
  },
  sagas: (actions) => ({
    [actions.fetchBusinessUnits]: fetchBusinessUnitsSagaFactory(actions),
    [actions.fetchUserBusinessUnits]:
      fetchUsersBusinessUnitsSagaFactory(actions),
  }),
});

export default Slice;
export const selectDataActions = Slice.actions;
